<div class="flex items-center" mat-dialog-title>
    <h2 class="headline m-0 flex-auto">
        {{ isEdit ? "Edit Stripe Config" : "New Stripe Config" }}
    </h2>

    <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
        <mat-icon svgIcon="mat:close"></mat-icon>
    </button>
</div>

<mat-divider class="text-border"></mat-divider>
<form [formGroup]="form">
    <mat-dialog-content class="grid grid-cols-1 md:grid-cols-1 gap-4">
        <mat-form-field>
            <mat-label>Secret Key</mat-label>
            <input formControlName="secretKey" matInput />
            <mat-error *ngIf="
          form.controls['secretKey'].hasError('required') &&
          form.controls['secretKey'].touched
        ">
                You must include a Secret Key
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Public Key</mat-label>
            <input formControlName="publicKey" matInput />
            <mat-error *ngIf="
              form.controls['publicKey'].hasError('required') &&
              form.controls['publicKey'].touched
            ">
                You must include a publicKey
            </mat-error>
        </mat-form-field>

    </mat-dialog-content>
</form>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">Cancel</button>
    <button color="primary" mat-flat-button type="submit" (click)="onSubmit()">
        <ng-container *ngIf="isEdit">Update Stripe Config</ng-container>
        <ng-container *ngIf="!isEdit">Create Stripe Config</ng-container>
    </button>
</mat-dialog-actions>